import React from "react";
import { ReactComponent as Phone } from "../../../assets/icons/phone.svg";
import { ReactComponent as Email } from "../../../assets/icons/email.svg";
import { useNavigate } from "react-router-dom";
import { App } from "../../../routes/Constants";
import infoConstants from "../../../shared/infoConstants";
import infoContactUs from "../../../shared/infoContactUs";

const contactLinkClass =
  "text-[#646464] no-underline transition-colors hover:text-[#374151]";

const ContactUs = () => {
  const navigate = useNavigate();

  const redirect = (URL) => {
    navigate(URL);
  };

  return (
    <main
      className="min-h-screen w-full overflow-y-auto bg-[#f8f8f8] px-4 pb-16 pt-16"
      data-testid="contact-us-page"
    >
      <div className="mx-auto w-full max-w-[600px] min-[851px]:max-w-[800px] min-[1201px]:max-w-[1100px]">
        <h1
          className="text-3xl font-semibold text-[#00567a]"
          data-testid="contact-us-heading"
        >
          Contact Us
        </h1>

        <section className="mb-2 mt-5" data-testid="contact-us-yellow-card-section">
          <p className="mt-5 text-justify text-base leading-relaxed text-[#646464]">
            Adverse events can also be reported online via the Yellow Card
            website{" "}
            <a
              href="https://yellowcard.mhra.gov.uk/"
              className={contactLinkClass}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-us-yellow-card-link"
            >
              https://yellowcard.mhra.gov.uk/
            </a>{" "}
            or search for MHRA Yellow Card in the Google Play or Apple App
            Store. Alternatively, prepaid Yellow Cards for reporting are
            available:
          </p>
          <ul className="ml-10 mt-3 list-disc space-y-1 text-justify text-base leading-snug text-[#646464]">
            <li>
              by writing to FREEPOST YELLOW CARD (no other address details
              necessary);
            </li>
            <li>by emailing yellowcard@mhra.gov.uk;</li>
            <li>
              by telephoning the Commission on Human Medicines (CHM) free phone
              line: 0800-731-6789;
            </li>
            <li>
              or by downloading and printing a form from the Yellow Card section
              of the MHRA website.
            </li>
          </ul>
        </section>

        <section className="mb-2 mt-5 space-y-6" data-testid="contact-us-support-section">
          <div
            className="mt-3 space-y-4"
            data-testid="contact-us-paf-issues"
          >
            <div>
              <h2 className="text-lg font-semibold text-[#00567a]">
                Prescription Authorisation Form Issues
              </h2>
              <p className="mt-2 mb-4 text-base text-[#646464]">
                To request assistance with prescription authorisation forms,
                please contact:
              </p>
              <div className="flex items-center gap-4">
                <Phone className="h-5 w-5 shrink-0" aria-hidden />
                <span className="text-base text-[#646464]">
                  Tel:{" "}
                  <a
                    className={contactLinkClass}
                    href={`tel:${infoConstants.nhsPhoneNumber}`}
                    data-testid="contact-us-paf-phone-link"
                  >
                    {infoConstants.nhsPhoneNumber}
                  </a>
                </span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <Email className="h-5 w-5 shrink-0" aria-hidden />
              <span className="text-base text-[#646464]">
                Email:{" "}
                <a
                  className={contactLinkClass}
                  href={`mailto:${infoConstants.nhsEmail}`}
                  data-testid="contact-us-paf-email-link"
                >
                  {infoConstants.nhsEmail}
                </a>
              </span>
            </div>
            <p className="ml-9 mt-2 text-base text-[#646464]">
              Mon - Fri 09:00 - 17:00
            </p>
          </div>

          <div
            className="mt-3 space-y-4"
            data-testid="contact-us-technical-issues"
          >
            <div>
              <h2 className="text-lg font-semibold text-[#00567a]">
                For Technical Issues:
              </h2>
              <p className="mt-2 mb-4 text-base text-[#646464]">
                To request assistance with any technical issues on the
                Pathfinder RMP, please contact:
              </p>
              <div className="flex items-center gap-4">
                <Phone className="h-5 w-5 shrink-0" aria-hidden />
                <span className="text-base text-[#646464]">
                  Tel:{" "}
                  <a
                    className={contactLinkClass}
                    href={`tel:${infoContactUs.nhsPhoneNumber}`}
                    data-testid="contact-us-tech-phone-link"
                  >
                    {infoContactUs.nhsPhoneNumber}
                  </a>
                </span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <Email className="h-5 w-5 shrink-0" aria-hidden />
              <span className="text-base text-[#646464]">
                Email:{" "}
                <a
                  className={contactLinkClass}
                  href={`mailto:${infoContactUs.nhsEmail}`}
                  data-testid="contact-us-tech-email-link"
                >
                  {infoContactUs.nhsEmail}
                </a>
              </span>
            </div>
            <p className="ml-9 mt-2 text-base text-[#646464]">
              Mon - Fri 09:00 - 17:00
            </p>
          </div>

          <div className="mt-5 mb-2" data-testid="contact-us-adverse-events">
            <h2 className="text-lg font-semibold text-[#00567a]">
              Medical Information and reporting Adverse Events and Pregnancies:
            </h2>
            <p className="mt-1 text-justify text-base text-[#646464]">
              Adverse Events (and cases of suspected or confirmed pregnancy or
              foetal exposure) should be reported. Adverse Event Report forms
              and Pregnancy Reporting forms can be found by following the link
              below.
            </p>
          </div>

          <div className="mt-5 mb-2">
            <button
              type="button"
              className="inline-flex h-[46px] min-w-[160px] cursor-pointer items-center justify-center rounded-full border-0 bg-[#00567a] px-6 text-lg font-bold leading-[22px] text-white hover:bg-[#005eb8]"
              onClick={() => redirect(App.REPORT_EVENT)}
              data-testid="contact-us-report-event-button"
            >
              Click here to access Adverse Event/Pregnancy report forms
            </button>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ContactUs;
